export const parseH3IndexesStr = (str: string | string[] | null): string[] => {
  if (!str) return [];

  if (Array.isArray(str) && str.every((ids) => typeof ids === "string")) {
    return str as string[];
  }

  return [];
};
